import React from 'react';
import { FiChevronDown, FiChevronRight, FiChevronUp } from 'react-icons/fi';
import { AiFillFolderOpen, AiOutlineFolder } from 'react-icons/ai';
import { FinderFolder, FinderFolderIcon, FinderFolderLabel } from '@/components/custom/finder';
import { IconWrapper } from '@/components/custom/icon';

export function LessonPlanFolder(props) {
  const { name, subFolders, isExpanded, setIsExpanded, onClick, isOpenFolder, folderId, setIdOpenedSubFolder, setCurrentFolder } = props;

  const chevronIcon = isOpenFolder ? <FiChevronRight /> : isOpenFolder || isExpanded === folderId ? <FiChevronUp /> : <FiChevronDown />;

  const handleToggle = e => {
    e.stopPropagation();

    if (subFolders?.length > 0) {
      setIsExpanded(prev => (prev === folderId ? null : folderId));
      setIdOpenedSubFolder(null);
      setCurrentFolder(null);
    }
  };

  return (
    <FinderFolder
      isOpen={isOpenFolder}
      onClick={onClick}
    >
      {isOpenFolder ? (
        <FinderFolderIcon>
          <AiFillFolderOpen />
        </FinderFolderIcon>
      ) : (
        <FinderFolderIcon>
          <AiOutlineFolder />
        </FinderFolderIcon>
      )}

      <FinderFolderLabel title={name}>{name}</FinderFolderLabel>

      <IconWrapper
        size="sm"
        asChild
      >
        <button onClick={handleToggle}>{chevronIcon}</button>
      </IconWrapper>
    </FinderFolder>
  );
}
